<template>
  <div class="whole home">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <!--      商城销售统计-->
      <div class="statistic">
        <div class="title">商城销售统计</div>
        <div class="con">
          <!--          商城-->
          <div class="flex-item">
            <!--            今日新增-->
            <div>
              <div class="title-item">
                <div class="text">今日新增</div>
                <el-button @click="onExport(1)">导出表格</el-button>
              </div>
              <table class="table1">
                <tr>
                  <td colspan="5">商城</td>
                </tr>
                <tr>
                  <td>新增订单</td>
                  <td>新增消费总额</td>
                  <td>产品成本</td>
                  <td>利润</td>
                  <td>V值总量</td>
                </tr>
                <tr>
                  <td>{{ sc.day.orderNum }}</td>
                  <td>{{ sc.day.totalPrices }}</td>
                  <td>{{ sc.day.costPrice }}</td>
                  <td>{{ sc.day.profit }}</td>
                  <td>{{ sc.day.uValue }}</td>
                </tr>
              </table>
            </div>
            <!--            本周新增-->
            <div>
              <div class="title-item">
                <div class="text">本周新增</div>
                <el-button @click="onExport(2)">导出表格</el-button>
              </div>
              <table class="table1">
                <tr>
                  <td colspan="5">商城</td>
                </tr>
                <tr>
                  <td>新增订单</td>
                  <td>新增消费总额</td>
                  <td>产品成本</td>
                  <td>利润</td>
                  <td>V值总量</td>
                </tr>
                <tr></tr>
                <tr>
                  <td>{{ sc.week.orderNum }}</td>
                  <td>{{ sc.week.totalPrices }}</td>
                  <td>{{ sc.week.costPrice }}</td>
                  <td>{{ sc.week.profit }}</td>
                  <td>{{ sc.week.uValue }}</td>
                </tr>
              </table>
            </div>
            <!--            本月新增-->
            <div>
              <div class="title-item">
                <div class="text">本月新增</div>
                <el-button @click="onExport(3)">导出表格</el-button>
              </div>
              <table class="table1">
                <tr>
                  <td colspan="5">商城</td>
                </tr>
                <tr>
                  <td>新增订单</td>
                  <td>新增消费总额</td>
                  <td>产品成本</td>
                  <td>利润</td>
                  <td>V值总量</td>
                </tr>
                <tr>
                  <td>{{ sc.month.orderNum }}</td>
                  <td>{{ sc.month.totalPrices }}</td>
                  <td>{{ sc.month.costPrice }}</td>
                  <td>{{ sc.month.profit }}</td>
                  <td>{{ sc.month.uValue }}</td>
                </tr>
              </table>
            </div>
          </div>
          <!--          分销-->
          <div class="flex-item">
            <!--            今日新增-->
            <div>
              <div class="title-item">
                <div></div>
                <el-button @click="onExportFx(1)">导出表格</el-button>
              </div>
              <table class="table1">
                <tr>
                  <td colspan="6">分销</td>
                </tr>
                <tr>
                  <td>新增订单</td>
                  <td>新增消费总额</td>
                  <td>产品成本</td>
                  <td>利润</td>
                  <td>佣金总值</td>
                  <td>V值总量</td>
                </tr>
                <tr>
                  <td>{{ scFx.day.orderNum }}</td>
                  <td>{{ scFx.day.totalPrices }}</td>
                  <td>{{ scFx.day.costPrice }}</td>
                  <td>{{ scFx.day.profit }}</td>
                  <td>{{ scFx.day.distributorBonus }}</td>
                  <td>{{ scFx.day.uValue }}</td>
                </tr>
              </table>
            </div>
            <!--            本周新增-->
            <div>
              <div class="title-item">
                <div></div>
                <el-button @click="onExportFx(2)">导出表格</el-button>
              </div>
              <table class="table1">
                <tr>
                  <td colspan="6">分销</td>
                </tr>
                <tr>
                  <td>新增订单</td>
                  <td>新增消费总额</td>
                  <td>产品成本</td>
                  <td>利润</td>
                  <td>佣金总值</td>
                  <td>V值总量</td>
                </tr>
                <tr>
                  <td>{{ scFx.week.orderNum }}</td>
                  <td>{{ scFx.week.totalPrices }}</td>
                  <td>{{ scFx.week.costPrice }}</td>
                  <td>{{ scFx.week.profit }}</td>
                  <td>{{ scFx.week.distributorBonus }}</td>
                  <td>{{ scFx.week.uValue }}</td>
                </tr>
              </table>
            </div>
            <!--           本月新增-->
            <div>
              <div class="title-item">
                <div></div>
                <el-button @click="onExportFx(3)">导出表格</el-button>
              </div>
              <table class="table1">
                <tr>
                  <td colspan="6">分销</td>
                </tr>
                <tr>
                  <td>新增订单</td>
                  <td>新增消费总额</td>
                  <td>产品成本</td>
                  <td>利润</td>
                  <td>佣金总值</td>
                  <td>V值总量</td>
                </tr>
                <tr>
                  <td>{{ scFx.month.orderNum }}</td>
                  <td>{{ scFx.month.totalPrices }}</td>
                  <td>{{ scFx.month.costPrice }}</td>
                  <td>{{ scFx.month.profit }}</td>
                  <td>{{ scFx.month.distributorBonus }}</td>
                  <td>{{ scFx.month.uValue }}</td>
                </tr>
              </table>
            </div>
          </div>
          <!--          复消-->
          <div class="flex-item">
            <!--            今日新增-->
            <div>
              <div class="title-item">
                <div />
                <div>
                  <!--                  <el-date-picker-->
                  <!--                    v-model="value1"-->
                  <!--                    type="daterange"-->
                  <!--                    range-separator="至"-->
                  <!--                    start-placeholder="开始日期"-->
                  <!--                    end-placeholder="结束日期">-->
                  <!--                  </el-date-picker>-->
                  <!--                  <el-button type="primary" @click="onExport">搜索</el-button>-->
                  <el-button @click="onExportFux(1)">导出表格</el-button>
                </div>
              </div>
              <table class="table1">
                <tr>
                  <td colspan="6">分销</td>
                </tr>
                <tr>
                  <td>新增订单</td>
                  <td>新增消费总额</td>
                  <td>产品成本</td>
                  <td>利润</td>
                  <td>佣金总量</td>
                </tr>
                <tr>
                  <td>{{ scFux.day.orderNum }}</td>
                  <td>{{ scFux.day.totalPrices }}</td>
                  <td>{{ scFux.day.costPrice }}</td>
                  <td>{{ scFux.day.profit }}</td>
                  <td>{{ scFux.day.repetitionBonus }}</td>
                </tr>
              </table>
            </div>
            <!--            本周新增-->
            <div>
              <div class="title-item">
                <div />
                <div>
                  <!--                  <el-date-picker-->
                  <!--                    v-model="value1"-->
                  <!--                    type="daterange"-->
                  <!--                    range-separator="至"-->
                  <!--                    start-placeholder="开始日期"-->
                  <!--                    end-placeholder="结束日期">-->
                  <!--                  </el-date-picker>-->
                  <!--                  <el-button type="primary" @click="onExport">搜索</el-button>-->
                  <el-button @click="onExportFux(2)">导出表格</el-button>
                </div>
              </div>
              <table class="table1">
                <tr>
                  <td colspan="6">分销</td>
                </tr>
                <tr>
                  <td>新增订单</td>
                  <td>新增消费总额</td>
                  <td>产品成本</td>
                  <td>利润</td>
                  <td>佣金总量</td>
                </tr>
                <tr>
                  <td>{{ scFux.week.orderNum }}</td>
                  <td>{{ scFux.week.totalPrices }}</td>
                  <td>{{ scFux.week.costPrice }}</td>
                  <td>{{ scFux.week.profit }}</td>
                  <td>{{ scFux.week.repetitionBonus }}</td>
                </tr>
              </table>
            </div>
            <!--           本月新增-->
            <div>
              <div class="title-item">
                <div />
                <div>
                  <!--                  <el-date-picker-->
                  <!--                    v-model="value1"-->
                  <!--                    type="daterange"-->
                  <!--                    range-separator="至"-->
                  <!--                    start-placeholder="开始日期"-->
                  <!--                    end-placeholder="结束日期">-->
                  <!--                  </el-date-picker>-->
                  <!--                  <el-button type="primary" @click="onExport">搜索</el-button>-->
                  <el-button @click="onExportFux(3)">导出表格</el-button>
                </div>
              </div>
              <table class="table1">
                <tr>
                  <td colspan="6">分销</td>
                </tr>
                <tr>
                  <td>新增订单</td>
                  <td>新增消费总额</td>
                  <td>产品成本</td>
                  <td>利润</td>
                  <td>佣金总量</td>
                </tr>
                <tr>
                  <td>{{ scFux.month.orderNum }}</td>
                  <td>{{ scFux.month.totalPrices }}</td>
                  <td>{{ scFux.month.costPrice }}</td>
                  <td>{{ scFux.month.profit }}</td>
                  <td>{{ scFux.month.repetitionBonus }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!--      门店销售统计-->
      <div class="statistic">
        <div class="title">门店销售统计</div>
        <div class="con">
          <!--          快捷买单-->
          <div class="flex-item1">
            <!--            今日新增-->
            <div>
              <div class="title-item">
                <div class="text">今日新增</div>
                <el-button @click="onExportMd(1)">导出表格</el-button>
              </div>
              <table class="table1">
                <tr>
                  <td colspan="5">快捷买单</td>
                </tr>
                <tr>
                  <td>新增订单</td>
                  <td>新增消费总额</td>
                  <td>门店成本</td>
                  <td>利润</td>
                  <td>V值总量</td>
                </tr>
                <tr>
                  <td>{{ md.day.orderNum }}</td>
                  <td>{{ md.day.money }}</td>
                  <td>{{ md.day.costPrice }}</td>
                  <td>{{ md.day.profit }}</td>
                  <td>{{ md.day.uValue }}</td>
                </tr>
              </table>
            </div>
            <!--            本周新增-->
            <div>
              <div class="title-item">
                <div class="text">本周新增</div>
                <el-button @click="onExportMd(2)">导出表格</el-button>
              </div>
              <table class="table1">
                <tr>
                  <td colspan="5">快捷买单</td>
                </tr>
                <tr>
                  <td>新增订单</td>
                  <td>新增消费总额</td>
                  <td>门店成本</td>
                  <td>利润</td>
                  <td>V值总量</td>
                </tr>
                <tr>
                  <td>{{ md.week.orderNum }}</td>
                  <td>{{ md.week.money }}</td>
                  <td>{{ md.week.costPrice }}</td>
                  <td>{{ md.week.profit }}</td>
                  <td>{{ md.week.uValue }}</td>
                </tr>
              </table>
            </div>
            <!--            本月新增-->
            <div>
              <div class="title-item">
                <div class="text">本月新增</div>
                <el-button @click="onExportMd(3)">导出表格</el-button>
              </div>
              <table class="table1">
                <tr>
                  <td colspan="5">快捷买单</td>
                </tr>
                <tr>
                  <td>新增订单</td>
                  <td>新增消费总额</td>
                  <td>门店成本</td>
                  <td>利润</td>
                  <td>V值总量</td>
                </tr>
                <tr>
                  <td>{{ md.month.orderNum }}</td>
                  <td>{{ md.month.money }}</td>
                  <td>{{ md.month.costPrice }}</td>
                  <td>{{ md.month.profit }}</td>
                  <td>{{ md.month.uValue }}</td>
                </tr>
              </table>
            </div>
          </div>
          <!--          店内活动产品-->
          <div class="flex-item1">
            <!--            今日新增-->
            <div>
              <div class="title-item">
                <div />
                <div>
                  <!--                  <el-date-picker-->
                  <!--                    v-model="value1"-->
                  <!--                    type="daterange"-->
                  <!--                    range-separator="至"-->
                  <!--                    start-placeholder="开始日期"-->
                  <!--                    end-placeholder="结束日期">-->
                  <!--                  </el-date-picker>-->
                  <!--                  <el-button type="primary" @click="onExport">搜索</el-button>-->
                  <el-button @click="onExportMdFd(1)">导出表格</el-button>
                </div>
              </div>
              <table class="table1">
                <tr>
                  <td colspan="5">店内活动产品</td>
                </tr>
                <tr>
                  <td>新增订单</td>
                  <td>新增消费总额</td>
                  <td>门店成本</td>
                  <td>利润</td>
                  <td>V值总量</td>
                </tr>
                <tr>
                  <td>{{ mdHd.day.orderNum }}</td>
                  <td>{{ mdHd.day.totalPrices }}</td>
                  <td>{{ mdHd.day.costPrice }}</td>
                  <td>{{ mdHd.day.profit }}</td>
                  <td>{{ mdHd.day.uValue }}</td>
                </tr>
              </table>
            </div>
            <!--            本周新增-->
            <div>
              <div class="title-item">
                <!-- <div /> -->
                <div>
                  <!--                  <el-date-picker-->
                  <!--                    v-model="value1"-->
                  <!--                    type="daterange"-->
                  <!--                    range-separator="至"-->
                  <!--                    start-placeholder="开始日期"-->
                  <!--                    end-placeholder="结束日期">-->
                  <!--                  </el-date-picker>-->
                  <!--                  <el-button type="primary" @click="onExport">搜索</el-button>-->
                  <el-button @click="onExportMdFd(2)">导出表格</el-button>
                </div>
              </div>
              <table class="table1">
                <tr>
                  <td colspan="5">店内活动产品</td>
                </tr>
                <tr>
                  <td>新增订单</td>
                  <td>新增消费总额</td>
                  <td>门店成本</td>
                  <td>利润</td>
                  <td>V值总量</td>
                </tr>
                <!-- <tr> -->
                <tr>
                  <td>{{ mdHd.week.orderNum }}</td>
                  <td>{{ mdHd.week.totalPrices }}</td>
                  <td>{{ mdHd.week.costPrice }}</td>
                  <td>{{ mdHd.week.profit }}</td>
                  <td>{{ mdHd.week.uValue }}</td>
                </tr>
              </table>
            </div>
            <!--            本月新增-->
            <div>
              <div class="title-item">
                <div>
                  <div>
                    <!--                  <el-date-picker-->
                    <!--                    v-model="value1"-->
                    <!--                    type="daterange"-->
                    <!--                    range-separator="至"-->
                    <!--                    start-placeholder="开始日期"-->
                    <!--                    end-placeholder="结束日期">-->
                    <!--                  </el-date-picker>-->
                    <!--                  <el-button type="primary" @click="onExport">搜索</el-button>-->
                    <el-button @click="onExportMdFd(3)">导出表格</el-button>
                  </div>
                </div>
                <table class="table1">
                  <tr>
                    <td colspan="5">店内活动产品</td>
                  </tr>
                  <tr>
                    <td>新增订单</td>
                    <td>新增消费总额</td>
                    <td>门店成本</td>
                    <td>利润</td>
                    <td>V值总量</td>
                  </tr>
                  <tr>
                    <td>{{ mdHd.month.orderNum }}</td>
                    <td>{{ mdHd.month.totalPrices }}</td>
                    <td>{{ mdHd.month.costPrice }}</td>
                    <td>{{ mdHd.month.profit }}</td>
                    <td>{{ mdHd.month.uValue }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!--      订单统计-->
        <div class="statistic">
          <div class="con">
            <!--          自提订单统计-->
            <div class="flex-item2">
              <div class="title">自提订单统计</div>
              <table class="table1">
                <tr>
                  <td>自提订单总额</td>
                  <td>已完成自提总额</td>
                  <td>自提佣金总额</td>
                </tr>
                <tr>
                  <td>{{ order1.amount }}</td>
                  <td>{{ order1.finishAmount }}</td>
                  <td>{{ order1.bonus }}</td>
                </tr>
              </table>
            </div>
            <!--          同城订单统计-->
            <div class="flex-item2">
              <div class="title">同城订单统计</div>
              <table class="table1">
                <tr>
                  <td>同城订单总额</td>
                  <td>同城佣金总额</td>
                </tr>
                <tr>
                  <td>{{ order2.amount }}</td>
                  <td>{{ order2.bonus }}</td>
                </tr>
              </table>
            </div>
            <!--          共享理疗统计-->
            <div class="flex-item2">
              <div class="title">共享理疗统计</div>
              <table class="table1">
                <tr>
                  <td>共享理疗次数</td>
                  <td>已理疗次数</td>
                  <td>当前理疗次数</td>
                </tr>
                <tr>
                  <td>{{ order3.sumTime }}</td>
                  <td>{{ order3.useTime }}</td>
                  <td>{{ order3.currentTime }}</td>
                </tr>
              </table>
            </div>
            <!--          权益积分统计-->
            <div class="flex-item2">
              <div class="title">权益积分</div>
              <table class="table1">
                <tr>
                  <td>积分库总量</td>
                  <td>已赠送积分总量</td>
                  <td>剩余积分总量</td>
                </tr>
                <tr>
                  <td>{{ order4.score }}</td>
                  <td>{{ order4.currentScore }}</td>
                  <td>{{ order4.surplusScore }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <!--      分项统计-->
        <div class="statistic">
          <div class="title" style="margin-bottom: 15px">分项统计</div>
          <div class="con">
            <!--          佣金统计-->
            <div class="flex-item">
              <table class="table1">
                <tr>
                  <td colspan="5">佣金统计</td>
                </tr>
                <tr>
                  <td>分销佣金总量</td>
                  <td>V值分红佣金总量</td>
                </tr>
                <tr>
                  <td>{{ fx1.bonus }}</td>
                  <td>{{ fx1.vValue }}</td>
                </tr>
              </table>
            </div>
            <!--          V红利-->
            <div class="flex-item">
              <table class="table1">
                <tr>
                  <td colspan="5">V值红利总量</td>
                </tr>
                <tr>
                  <td>团期</td>
                  <td>共享红利</td>
                  <td>分享红利</td>
                  <td>市场红利</td>
                </tr>
                <tr>
                  <td style="padding: 3px 10px 0px 10px">
                    <el-select
                      v-model="fxId"
                      @change="onChangeTq"
                      class="fx2-select"
                    >
                      <el-option
                        v-for="item in fx2List"
                        :key="item.id"
                        :label="item.tranche"
                        :value="item.id"
                      />
                    </el-select>
                  </td>
                  <td>{{ fx2.share }}</td>
                  <td>{{ fx2.sharing }}</td>
                  <td>{{ fx2.market }}</td>
                </tr>
              </table>
            </div>
            <!--          佣金提现-->
            <div class="flex-item">
              <table class="table1">
                <tr>
                  <td colspan="5">佣金提现统计</td>
                </tr>
                <tr>
                  <td>已提现佣金总额</td>
                  <td>手续费总额</td>
                  <td>转钱包总额</td>
                  <td>当前佣金总额</td>
                </tr>
                <tr>
                  <td>{{ fx3.money }}</td>
                  <td>{{ fx3.serviceCharge }}</td>
                  <td>{{ fx3.balance }}</td>
                  <td>{{ fx3.earnings }}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="con" style="margin-top: 20px">
            <!--          钱包统计-->
            <div class="flex-item1">
              <table class="table1">
                <tr>
                  <td colspan="5">钱包统计</td>
                </tr>
                <tr>
                  <td>钱包累计总额</td>
                  <td>转消费券总额</td>
                  <td>当前钱包总额</td>
                </tr>
                <tr>
                  <td>{{ fx4.balanceSum }}</td>
                  <td>{{ fx4.toCashCoupon }}</td>
                  <td>{{ fx4.currentBalance }}</td>
                </tr>
              </table>
            </div>
            <!--          消费券统计-->
            <div class="flex-item1">
              <table class="table1">
                <tr>
                  <td colspan="5">消费券统计</td>
                </tr>
                <tr>
                  <td>消费券累积总额</td>
                  <td>消费券支付总额</td>
                  <td>当前消费券总额</td>
                </tr>
                <tr>
                  <td>{{ fx5.cashCoupon }}</td>
                  <td>{{ fx5.useCashCoupon }}</td>
                  <td>{{ fx5.currentCashCoupon }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <!--      V统计-->
        <div class="statistic">
          <div class="con">
            <!--          V值统计-->
            <div class="flex-item1">
              <div class="title" style="margin-bottom: 15px">V值统计</div>
              <table class="table1">
                <tr>
                  <td>V值累积总量</td>
                  <td>已参与拼单总额</td>
                  <td>当前V值总额</td>
                </tr>
                <tr>
                  <td>{{ v1.vValue }}</td>
                  <td>{{ v1.crowdfundingValue }}</td>
                  <td>{{ v1.currentValue }}</td>
                </tr>
              </table>
            </div>
            <!--          V金总计-->
            <div class="flex-item1">
              <div class="title" style="margin-bottom: 15px">V金总计</div>
              <table class="table1">
                <tr>
                  <td>V金累积总量</td>
                  <td>已分红总额</td>
                  <td>当前V金总额</td>
                </tr>
                <tr>
                  <td>{{ v2.vGold }}</td>
                  <td>{{ v2.shareVGold }}</td>
                  <td>{{ v2.currentVGold }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <!--      支付方式统计-->
        <div class="statistic">
          <div class="title" style="margin-bottom: 15px">支付方式统计</div>
          <div class="con">
            <table class="table1">
              <tr>
                <td>支付方式</td>
                <td>消费积累总额</td>
                <td>今日统计</td>
                <td>本周统计</td>
                <td>本月统计</td>
              </tr>
              <tr>
                <td>支付宝</td>
                <td>{{ pay.sum.aliPay }}</td>
                <td>{{ pay.day.aliPay }}</td>
                <td>{{ pay.week.aliPay }}</td>
                <td>{{ pay.month.aliPay }}</td>
              </tr>
              <tr>
                <td>微信</td>
                <td>{{ pay.sum.weChatPay }}</td>
                <td>{{ pay.day.weChatPay }}</td>
                <td>{{ pay.week.weChatPay }}</td>
                <td>{{ pay.month.weChatPay }}</td>
              </tr>
              <tr>
                <td>消费券</td>
                <td>{{ pay.sum.couponPay }}</td>
                <td>{{ pay.day.couponPay }}</td>
                <td>{{ pay.week.couponPay }}</td>
                <td>{{ pay.month.couponPay }}</td>
              </tr>
            </table>
          </div>
        </div>
        <!--      个人排行榜-->
        <div class="statistic">
          <div class="title">个人排行榜</div>
          <div class="con">
            <!--          总业绩排行前30名-->
            <div class="flex-item">
              <div class="title-item">
                <div />
                <el-button @click="onExportGr1">导出表格</el-button>
              </div>
              <div class="grTable1 grTable">
                <table class="table1">
                  <tr>
                    <td colspan="5">总业绩排行前30名</td>
                  </tr>
                  <tr>
                    <td>排名</td>
                    <td>手机号</td>
                    <td>市场总业绩</td>
                  </tr>
                  <tr v-for="item in grList1" :key="item.id">
                    <td>{{ item.num }}</td>
                    <td>{{ item.phone }}</td>
                    <td>{{ item.totalPerformance }}</td>
                  </tr>
                </table>
              </div>
              <el-button type="text" @click="onGr1Open" class="btn-open">{{
                grText1
              }}</el-button>
            </div>
            <!--          个人消费排行前30名-->
            <div class="flex-item">
              <div class="title-item">
                <div />
                <el-button @click="onExportGr2">导出表格</el-button>
              </div>
              <div class="grTable2 grTable">
                <table class="table1">
                  <tr>
                    <td colspan="5">个人消费排行前30名</td>
                  </tr>
                  <tr>
                    <td>排名</td>
                    <td>手机号</td>
                    <td>累积消费总值</td>
                  </tr>
                  <tr v-for="item in grList2" :key="item.id">
                    <td>{{ item.num }}</td>
                    <td>{{ item.phone }}</td>
                    <td>{{ item.totalMoney }}</td>
                  </tr>
                </table>
              </div>
              <el-button type="text" @click="onGr2Open" class="btn-open">{{
                grText2
              }}</el-button>
            </div>
            <!--          个人消费Q值前30名-->
            <div class="flex-item">
              <div class="title-item">
                <div />
                <el-button @click="onExportGr3">导出表格</el-button>
              </div>
              <div class="grTable3 grTable">
                <table class="table1">
                  <tr>
                    <td colspan="5">个人消费Q值前30名</td>
                  </tr>
                  <tr>
                    <td>排名</td>
                    <td>手机号</td>
                    <td>Q总值</td>
                    <td>当前Q值</td>
                  </tr>
                  <tr v-for="item in grList3" :key="item.id">
                    <td>{{ item.num }}</td>
                    <td>{{ item.phone }}</td>
                    <td>{{ item.totalUValue }}</td>
                    <td>{{ item.uValue }}</td>
                  </tr>
                </table>
              </div>
              <el-button type="text" @click="onGr3Open" class="btn-open">{{
                grText3
              }}</el-button>
            </div>
          </div>
          <!--          推广收益排名前30名-->

          <div class="con" style="margin-top: 20px">
            <div class="flex-item3">
              <div class="title-item">
                <div />
                <el-button @click="onExportGr4">导出表格</el-button>
              </div>
              <div class="grTable4 grTable">
                <table class="table1">
                  <tr>
                    <td colspan="6">推广收益排名前30名</td>
                  </tr>
                  <tr>
                    <td>排名</td>
                    <td>手机号</td>
                    <td>总收益</td>
                    <td>当前账户余额</td>
                    <td>钱包总额</td>
                    <td>消费券总额</td>
                  </tr>
                  <tr v-for="item in grList4" :key="item.id">
                    <td>{{ item.num }}</td>
                    <td>{{ item.phone }}</td>
                    <td>{{ item.sumEarnings }}</td>
                    <td>{{ item.balance }}</td>
                    <td>{{ item.earnings }}</td>
                    <td>{{ item.cashCcoupon }}</td>
                  </tr>
                </table>
              </div>
              <el-button type="text" @click="onGr4Open" class="btn-open">{{
                grText4
              }}</el-button>
            </div>
          </div>
        </div>
        <!--      门店排行榜-->
        <div class="statistic">
          <div class="title">门店排行榜</div>
          <div class="con">
            <!--          营业收入前30名-->
            <div class="flex-item1">
              <div class="title-item">
                <div />
                <el-button @click="onExportMd1">导出表格</el-button>
              </div>
              <div class="mdTable1 mdTable">
                <table class="table1">
                  <tr>
                    <td colspan="5">营业收入前30名</td>
                  </tr>
                  <tr>
                    <td>排名</td>
                    <td>门店名称</td>
                    <td>所属地</td>
                    <td>营业总收入</td>
                    <td>当前账户余额</td>
                  </tr>
                  <tr v-for="item in mdList1" :key="item.id">
                    <td>{{ item.num }}</td>
                    <td>{{ item.storeName }}</td>
                    <td>{{ item.address }}</td>
                    <td>{{ item.money }}</td>
                    <td>{{ item.account }}</td>
                  </tr>
                </table>
              </div>
              <el-button type="text" @click="onMd1Open" class="btn-open">{{
                mdText1
              }}</el-button>
            </div>
            <!--          自提订单服务前30名-->
            <div class="flex-item1">
              <div class="title-item">
                <div />
                <el-button @click="onExportMd2">导出表格</el-button>
              </div>
              <div class="mdTable1 mdTable">
                <table class="table1">
                  <tr>
                    <td colspan="5">自提订单服务前30名</td>
                  </tr>
                  <tr>
                    <td>排名</td>
                    <td>门店名称</td>
                    <td>所属地</td>
                    <td>自提服务订单总量</td>
                    <td>服务费总额</td>
                  </tr>
                  <tr v-for="item in mdList2" :key="item.id">
                    <td>{{ item.num }}</td>
                    <td>{{ item.storeName }}</td>
                    <td>{{ item.address }}</td>
                    <td>{{ item.orderNum }}</td>
                    <td>{{ item.money }}</td>
                  </tr>
                </table>
              </div>
              <el-button type="text" @click="onMd2Open" class="btn-open">{{
                mdText2
              }}</el-button>
            </div>
          </div>
          <div class="con">
            <!--          共享理疗服务前30名-->
            <div class="flex-item1">
              <div class="title-item">
                <!-- <div/> -->
                <el-button @click="onExportMd3">导出表格</el-button>
              </div>
              <div class="mdTable1 mdTable">
                <table class="table1">
                  <tr>
                    <td colspan="5">共享理疗服务前30名</td>
                  </tr>
                  <tr>
                    <td>排名</td>
                    <td>门店名称</td>
                    <td>所属地</td>
                    <td>共享理疗次数</td>
                    <td>理疗收益总额</td>
                  </tr>
                  <tr v-for="item in mdList3" :key="item.id">
                    <td>{{ item.num }}</td>
                    <td>{{ item.storeName }}</td>
                    <td>{{ item.address }}</td>
                    <td>{{ item.serviceNum }}</td>
                    <td>{{ item.money }}</td>
                  </tr>
                </table>
              </div>
              <el-button type="text" @click="onMd3Open" class="btn-open">{{
                mdText3
              }}</el-button>
            </div>
            <!--          门店进货前30名-->
            <div class="flex-item1">
              <div class="title-item">
                <!-- <div/> -->
                <el-button @click="onExportMd4">导出表格</el-button>
              </div>
              <div class="mdTable1 mdTable">
                <table class="table1">
                  <tr>
                    <td colspan="4">门店进货前30名</td>
                  </tr>
                  <tr>
                    <td>排名</td>
                    <td>门店名称</td>
                    <td>所属地</td>
                    <td>进货总额</td>
                  </tr>
                  <tr v-for="item in mdList4" :key="item.id">
                    <td>{{ item.num }}</td>
                    <td>{{ item.storeName }}</td>
                    <td>{{ item.address }}</td>
                    <td>{{ item.amountTotal }}</td>
                  </tr>
                </table>
              </div>
              <el-button type="text" @click="onMd4Open" class="btn-open">{{
                mdText4
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MSidebar from "components/header/sidebar";
import MHeader from "components/header/header";
import {
  homeData11,
  homeData11Export,
  homeData12,
  homeData12Export,
  homeData13,
  homeData13Export,
  homeData21,
  homeData21Export,
  homeData22,
  homeData22Export,
  homeData31,
  homeData41,
  homeData51,
  homeData61,
  homeData71,
  homeData721,
  homeData722,
  homeData73,
  homeData74,
  homeData75,
  homeData81,
  homeData91,
  homeData101,
  homeData111,
  homeData111Export,
  homeData112,
  homeData112Export,
  homeData113,
  homeData113Export,
  homeData114,
  homeData114Export,
  homeData121,
  homeData121Export,
  homeData122,
  homeData122Export,
  homeData123,
  homeData123Export,
  homeData124,
  homeData124Export
} from "api/request";
import { Loading } from "element-ui";
import { loadingInstance, Success, Error } from "common/js/util";
import { ERR_OK } from "../../api/config";
import $ from "jquery";

export default {
  components: { MSidebar, MHeader },
  data() {
    return {
      value1: "",
      sc: { day: {}, month: {}, week: {} },
      scFx: { day: {}, month: {}, week: {} },
      scFux: { day: {}, month: {}, week: {} },
      md: { day: {}, month: {}, week: {} },
      mdHd: { day: {}, month: {}, week: {} },
      order1: {},
      order2: {},
      order3: {},
      order4: {},
      fx1: {},
      fx2List: [],
      fx2: {},
      fx3: {},
      fx4: {},
      fx5: {},
      fxId: "",
      v1: {},
      v2: {},
      pay: { day: {}, month: {}, week: {}, sum: {} },
      grList1: [],
      grList2: [],
      grList3: [],
      grList4: [],
      grText1: "展开",
      grText2: "展开",
      grText3: "展开",
      grText4: "展开",
      mdList1: [],
      mdList2: [],
      mdList3: [],
      mdList4: [],
      mdText1: "展开",
      mdText2: "展开",
      mdText3: "展开",
      mdText4: "展开"
    };
  },
  mounted() {
    let getUserInfo = JSON.parse(window.localStorage.getItem("getUserInfo"));
    if (!getUserInfo) {
      this.$router.push({
        path: "/"
      });
    } else {
      this._getSC();
      this._getScFx();
      this._getScFux();
      this._getMd();
      this._getMdHd();
      this._getOrder1();
      this._getOrder2();
      this._getOrder3();
      this._getOrder4();
      this._getFx1();
      this._getFx2List();
      // this._getFx2()
      this._getFx3();
      this._getFx4();
      this._getFx5();
      this._getV1();
      this._getV2();
      this._getPay();
      this._getGrList1();
      this._getGrList2();
      this._getGrList3();
      this._getGrList4();
      this._getMdList1();
      this._getMdList2();
      this._getMdList3();
      this._getMdList4();
    }
  },
  methods: {
    // 商城统计
    _getSC() {
      loadingInstance(Loading);
      homeData11().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.sc = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // 商城导出
    onExport(type) {
      location.href = homeData11Export + "type=" + type;
    },
    //商城分销
    _getScFx() {
      loadingInstance(Loading);
      homeData12().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.scFx = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //商城分销导出
    onExportFx(type) {
      location.href = homeData12Export + "type=" + type;
    },
    //商城复消
    _getScFux() {
      loadingInstance(Loading);
      homeData13().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.scFux = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //商城复消导出
    onExportFux() {
      location.href = homeData13Export + "type=" + type;
    },
    //门店快捷买单
    _getMd() {
      loadingInstance(Loading);
      homeData21().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.md = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //门店快捷买单导出
    onExportMd(type) {
      location.href = homeData21Export + "type=" + type;
    },
    //门店活动
    _getMdHd() {
      loadingInstance(Loading);
      homeData22().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.mdHd = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //门店活动导出
    onExportMdFd() {
      location.href = homeData22Export + "type=" + type;
    },
    // 自提订单统计
    _getOrder1() {
      loadingInstance(Loading);
      homeData31().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.order1 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // 同城订单统计
    _getOrder2() {
      loadingInstance(Loading);
      homeData41().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.order2 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // 共享理疗统计
    _getOrder3() {
      loadingInstance(Loading);
      homeData51().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.order3 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // 权益积分
    _getOrder4() {
      loadingInstance(Loading);
      homeData61().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.order4 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // 分项统计-佣金统计
    _getFx1() {
      loadingInstance(Loading);
      homeData71().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.fx1 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // 分项统计-V值红利-众筹期数
    _getFx2List() {
      loadingInstance(Loading);
      homeData721().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.fx2List = res.data;
          if (res.data && res.data.length > 0) {
            let id = res.data[0].id;
            this.fxId = id;
            this._getFx2(id);
          }
        } else {
          Error(this, res);
        }
      });
    },
    //分享统计--修改期数
    onChangeTq(id) {
      this._getFx2(id);
    },
    // 分项统计-V值红利
    _getFx2(id) {
      loadingInstance(Loading);
      homeData722({ crowdfundingId: id || this.fxId }).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.fx2 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // 分项统计-钱包统计
    _getFx3() {
      loadingInstance(Loading);
      homeData73().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.fx3 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // 分项统计-佣金统计
    _getFx4() {
      loadingInstance(Loading);
      homeData74().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.fx4 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // 分项统计-消费券统计
    _getFx5() {
      loadingInstance(Loading);
      homeData75().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.fx5 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // V值统计
    _getV1() {
      loadingInstance(Loading);
      homeData81().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.v1 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // V金统计
    _getV2() {
      loadingInstance(Loading);
      homeData91().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.v2 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // 支付方式统计
    _getPay() {
      loadingInstance(Loading);
      homeData101().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.pay = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //个人排行榜-市场业绩
    _getGrList1() {
      loadingInstance(Loading);
      homeData111({ limit: 30 }).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.grList1 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //个人排行榜-市场业绩-导出
    onExportGr1() {
      location.href = homeData111Export;
    },
    //个人排行榜-市场业绩-展开
    onGr1Open() {
      if (this.grText1 == "收起") {
        $(".grTable1").css({ height: "444px" });
        this.grText1 = "展开";
      } else {
        $(".grTable1").css({ height: "auto" });
        this.grText1 = "收起";
      }
    },
    //个人排行榜-消费金额
    _getGrList2() {
      loadingInstance(Loading);
      homeData112({ limit: 30 }).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.grList2 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //个人排行榜-消费金额-导出
    onExportGr2() {
      location.href = homeData112Export;
    },
    //个人排行榜-消费金额-展开
    onGr2Open() {
      if (this.grText2 == "收起") {
        $(".grTable2").css({ height: "444px" });
        this.grText2 = "展开";
      } else {
        $(".grTable2").css({ height: "auto" });
        this.grText2 = "收起";
      }
    },
    //个人排行榜-Q值
    _getGrList3() {
      loadingInstance(Loading);
      homeData113({ limit: 30 }).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.grList3 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //个人排行榜-Q值-导出
    onExportGr3() {
      location.href = homeData113Export;
    },
    //个人排行榜-Q值-展开
    onGr3Open() {
      if (this.grText3 == "收起") {
        $(".grTable3").css({ height: "444px" });
        this.grText3 = "展开";
      } else {
        $(".grTable3").css({ height: "auto" });
        this.grText3 = "收起";
      }
    },
    //个人排行榜-推广收益
    _getGrList4() {
      loadingInstance(Loading);
      homeData114({ limit: 30 }).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.grList4 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //个人排行榜-推广收益-导出
    onExportGr4() {
      location.href = homeData114Export;
    },
    //个人排行榜-推广收益-展开
    onGr4Open() {
      if (this.grText4 == "收起") {
        $(".grTable4").css({ height: "444px" });
        this.grText4 = "展开";
      } else {
        $(".grTable4").css({ height: "auto" });
        this.grText4 = "收起";
      }
    },
    //门店排行榜-营业额
    _getMdList1() {
      loadingInstance(Loading);
      homeData121({ limit: 30 }).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.mdList1 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //门店排行榜-营业额-导出
    onExportMd1() {
      location.href = homeData121Export;
    },
    //门店排行榜-营业额-展开
    onMd1Open() {
      if (this.mdText1 == "收起") {
        $(".mdTable2").css({ height: "444px" });
        this.mdText1 = "展开";
      } else {
        $(".mdTable2").css({ height: "auto" });
        this.mdText1 = "收起";
      }
    },
    //门店排行榜-自提
    _getMdList2() {
      loadingInstance(Loading);
      homeData122({ limit: 30 }).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.mdList2 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //门店排行榜-自提-导出
    onExportMd2() {
      location.href = homeData122Export;
    },
    //门店排行榜-自提-展开
    onMd2Open() {
      if (this.mdText2 == "收起") {
        $(".mdTable2").css({ height: "444px" });
        this.mdText2 = "展开";
      } else {
        $(".mdTable2").css({ height: "auto" });
        this.mdText2 = "收起";
      }
    },
    //门店排行榜-共享理疗
    _getMdList3() {
      loadingInstance(Loading);
      homeData123({ limit: 30 }).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.mdList3 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //门店排行榜-共享理疗-导出
    onExportMd3() {
      location.href = homeData123Export;
    },
    //门店排行榜-共享理疗-展开
    onMd3Open() {
      if (this.mdText3 == "收起") {
        $(".mdTable2").css({ height: "444px" });
        this.mdText3 = "展开";
      } else {
        $(".mdTable2").css({ height: "auto" });
        this.mdText3 = "收起";
      }
    },
    //门店排行榜-进货
    _getMdList4() {
      loadingInstance(Loading);
      homeData124({ limit: 30 }).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.mdList4 = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //门店排行榜-进货-导出
    onExportMd4() {
      location.href = homeData124Export;
    },
    //门店排行榜-进货-展开
    onMd4Open() {
      if (this.mdText4 == "收起") {
        $(".mdTable2").css({ height: "444px" });
        this.mdText4 = "展开";
      } else {
        $(".mdTable2").css({ height: "auto" });
        this.mdText4 = "收起";
      }
    }
  }
};
</script>
<style scoped>
.home .statistic {
  /*width: 100%;*/
  padding: 20px 15px;
  border-bottom: 1px solid #ccc;
}

.home .statistic .title {
  color: red;
  font-size: 16px;
  font-weight: bold;
}

.home .statistic .con {
  display: flex;
  justify-content: space-between;
}

.home .statistic .con .flex-item {
  width: 32%;
}
.home .statistic .con .flex-item1 {
  width: 49%;
}
.home .statistic .con .flex-item2 {
  width: 24%;
}
.home .statistic .con .flex-item3 {
  width: 100%;
}

.home .flex-item2 .title {
  margin-bottom: 15px;
}

.home .statistic .con .flex-item .text,
.home .statistic .con .flex-item1 .text,
.home .statistic .con .flex-item2 .text,
.home .statistic .con .flex-item3 .text {
  font-weight: bold;
}

.home .statistic .title-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0 10px 0;
}

.home .table1 {
  width: 100%;
}

.home .table1 tr:nth-child(odd) {
  background-color: #efefef;
}

.home .table1 tr td {
  border: 1px solid #ddd;
  padding: 10px;
}
.home .grTable,
.home .mdTable {
  height: 444px;
  overflow: hidden;
}
.home .btn-open {
  display: block;
  margin: 0 auto;
}

.home .fx2-select {
  width: 100px;
  height: 30px;
  overflow: hidden;
}
.home .fx2-select .el-input__inner {
  height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue